import React from "react";

export const ui = {
  input:
    "mt-2 bg-white/70 border-[#E4DACB] rounded-xl h-12 text-[#2C2A28] placeholder:text-[#A99F90] focus-visible:ring-[#C6A45C] focus-visible:border-[#C6A45C]",
  label: "text-xs uppercase tracking-[0.14em] text-[#8A7F70]",
  dialog: "bg-[#FBF7F1] border-[#EAE0D2] text-[#2C2A28] rounded-3xl",
  selectTrigger: "mt-2 bg-white/70 border-[#E4DACB] rounded-xl text-[#2C2A28]",
  selectContent: "bg-[#FBF7F1] border-[#EAE0D2] text-[#2C2A28]",
};

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 fade-up">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight text-[#2C2A28]">{title}</h1>
        {subtitle && <p className="text-[#8A7F70] text-sm mt-2">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function GoldButton({ children, className = "", ...props }) {
  return (
    <button
      className={`bg-gradient-to-br from-[#D8BE83] to-[#C6A45C] text-[#3a2f1a] font-medium px-5 py-2.5 rounded-full shadow-[0_4px_14px_rgba(198,164,92,0.35)] hover:shadow-[0_6px_22px_rgba(198,164,92,0.5)] hover:-translate-y-0.5 transition-all text-sm flex items-center justify-center gap-2 disabled:opacity-60 disabled:hover:translate-y-0 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function OutlineButton({ children, className = "", ...props }) {
  return (
    <button
      className={`border border-[#D9CDBA] text-[#6b6256] bg-white/50 px-4 py-2.5 rounded-full hover:bg-white hover:border-[#C6A45C] transition-all text-sm flex items-center justify-center gap-2 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function Card({ children, className = "", ...props }) {
  return (
    <div className={`glass-card rounded-2xl p-6 md:p-7 ${className}`} {...props}>
      {children}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {Icon && (
        <div className="w-14 h-14 rounded-full bg-[#F0E7D8] flex items-center justify-center mb-4">
          <Icon size={26} strokeWidth={1.4} className="text-[#C6A45C]" />
        </div>
      )}
      <div className="text-[#2C2A28] font-display text-xl">{title}</div>
      {hint && <div className="text-[#8A7F70] text-sm mt-2 max-w-sm">{hint}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
